import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const taskActionTypes = {
  EMAIL: "EMAIL",
  PHONE_CALL: "PHONE_CALL",
};

export const tasksStatuses = ["Todo", "Done"];

export const taskStatusTypes = {
  TODO: "Todo",
  PENDING: "PENDING",
  COMPLETE: "COMPLETE",
  DONE: "DONE",
  Done: "Done",
};

export const taskErrorTypes = {
  TASK_NOT_FOUND: "Task not found",
  QUEUE_EMPTY: "Queue is empty",
};

export const emailReminderOptions = [
  { value: "no_reminder", label: "No reminder" },
  { value: "at_due_time", label: "At task due time" },
  { value: "30_mins_before", label: "30 mins before" },
  { value: "1_hour_before", label: "1 hour before" },
  { value: "1_day_before", label: "1 day before" },
  { value: "1_week_before", label: "1 week before" },
  { value: "custom_date", label: "Custom date" },
];

export const getDateOptions = () => {
  const today = dayjs();
  const tomorrow = dayjs().add(1, "day");

  return [
    {
      value: null,
      label: "No Due Date",
      date: null,
    },
    {
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Tomorrow",
      date: tomorrow,
    },
    {
      value: today.format("YYYY-MM-DD"),
      label: "Today",
      date: today,
    },
    {
      value: "custom",
      label: "Custom Date",
      date: null,
    },
  ];
};

export const taskHeaders = [
  { title: "Name", key: "title", width: 4 },
  { title: "Assignees", key: "assignee_names", width: 1, view: true },
  { title: "Status", key: "status", width: 1, view: true },
  { title: "Type", key: "task_type", width: 1 },
  { title: "Priority", key: "priority", width: 1 },
  { title: "Due Date and Time", key: "due_date", width: 1 },
  { title: "Completion Date", key: "completed_date", width: 1 },
  {
    title: "Associated Company",
    key: "company_names",
    width: 1,
    avatar: "logo_url",
    view: true,
  },
  {
    title: "Associated Lead",
    key: "lead_names",
    width: 1,
    avatar: "profile_pic",
    view: true,
  },
  {
    title: "Associated Contact",
    key: "contact_names",
    width: 1,
    avatar: "profile_pic",
    view: true,
  },
];
